// @flow
import React, { Component } from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import musicmode from '../images/musicmode.png';
import { socketEmit } from "../../../../../socket/index"
import { translate } from '../../../base/i18n';
import { connect } from 'react-redux';
import { showToastPopup } from '../../redux/tool-webjam/actions';
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2 } from '../../constant';
import { dispatch, getBaseConfig, MUSIC_MODE_STRING } from '../../Utils';
import { toggleLobbyMode } from '../../../lobby/actions.any';
import { isLocalParticipantModerator } from '../../../base/participants';
// import { Checkbox } from '@atlaskit/checkbox';
import { messages } from '../../welcome-dashboard/messages';
import { sendAnalytics } from '../../../analytics';
import { musicModeStatus } from '../../welcome-dashboard/Request.d';
import { CURRENT_ROOM_LOCATION, CURRENT_ROOM_NAME } from '../../../webjam/constant';
import Checkbox from '../../../base/ui/components/web/Checkbox'
import { ct } from '../../constant-Utils';
import Dialog from '../../../base/ui/components/web/Dialog';

type Props = {

    /**
     * External handler for click action.
     */
    handleClick: Function,

    /**
     * Indicates whether audio permissions have been granted or denied.
     */
    hasPermissions: boolean,

    /**
     * Click handler for the small icon. Opens audio options.
     */
    onAudioOptionsClick: Function,

    /**
     * If the button should be disabled.
     */
    isDisabled: boolean,

    /**
     * Used for translation.
     */
    t: Function,

    /**
     * Flag controlling the visibility of the button.
     * AudioSettings popup is disabled on mobile browsers.
     */
    visible: boolean,

    /**
     * Defines is popup is open
     */
    isOpen: boolean,
};

/**
 * Button used for audio & audio settings.
 *
 * @returns {ReactElement}
 */
class MusicModeButton extends Component<Props> {
    /**
     * Initializes a new {@code MusicModeButton} instance.
     *
     * @inheritdoc
     */

    state = {
        isNoHelpModal: false,
        isShowHelpModal: false,
        isDominant: false,
        isLoading: false
    }

    constructor(props: Props) {
        super(props);

        this._onEscClick = this._onEscClick.bind(this);
        this._onClick = this._onClick.bind(this);
    }

    componentDidMount() {
        const { disableAEC, disableAGC, disableAP, disableHPF } = window.config;

        if (disableAEC === false && disableAGC === false && disableAP === true && disableHPF === false) {
            this.setState({
                isDominant: true
            });

        } else {
            this.setState({
                isDominant: false
            });
        }
    }


    componentDidUpdate(prevProps) {
        if (this.props.conferenceJoined != prevProps.conferenceJoined) {
            if (this.props.conferenceJoined) {

                let _this = this;
                setTimeout(function () {
                    const { tokenDecodedData, authOrganization } = _this.props;
                    if (tokenDecodedData) {
                        let musicCheckPay = {
                            method: "GET",
                            query: "?roomname=" + tokenDecodedData.roomName + "&school=" + tokenDecodedData.school + "&organization_id=" + authOrganization._id
                        }
                        // Check is music mode is enabled front backend in case of duet
                        if (_this.state.isDominant == false) {
                            musicModeStatus(musicCheckPay).then(musicData => {
                                if (musicData.status == 1) {
                                    if (musicData?.musicMode == true) {
                                        dispatch(showToastPopup({ toastModal: true, modalText: ct("messages.musicModeDetected", "messages") }));
                                        setTimeout(function () {
                                            sessionStorage.removeItem("claimedUserD")
                                            sessionStorage.setItem("claimedUserD", JSON.stringify({
                                                roomLocation: CURRENT_ROOM_LOCATION,
                                                time: Math.round(new Date().getTime() / 1000),
                                                roomName: tokenDecodedData.roomName,
                                                tokenDecodedData: tokenDecodedData
                                            }))
                                            let room = CURRENT_ROOM_NAME;
                                            // if (room) {
                                            //     room = room.substring(1);
                                            // }

                                            sessionStorage.removeItem("conference_time_" + room);
                                            window.location.hash = MUSIC_MODE_STRING;
                                            location.reload();
                                        }, 5000)
                                    }
                                }
                            })
                        } else if (_this.state.isDominant == true) {
                            // Update music mode status in the backend if my local music mode status is enabled
                            if (tokenDecodedData.teacher) {
                                let musicModeData = {
                                    method: "POST",
                                    music_mode: true,
                                    roomname: tokenDecodedData.roomName,
                                    school: tokenDecodedData.school,
                                    organization_id: authOrganization._id
                                }
                                musicModeStatus(musicModeData).then((e) => {
                                    console.log("music mode status first", e)
                                })
                            }
                        }
                    }
                }, 3000)
            }
        }
    }

    _onEscClick: (KeyboardEvent) => void;

    /**
     * Click handler for the more actions entries.
     *
     * @param {KeyboardEvent} event - Esc key click to close the popup.
     * @returns {void}
     */
    _onEscClick(event) {
        if (event.key === 'Escape' && this.props.isOpen) {
            event.preventDefault();
            event.stopPropagation();
            this._onClick();
        }
    }

    _onClick: () => void;

    /**
     * Click handler for the more actions entries.
     *
     * @returns {void}
     */
    _onClick(checked) {
        if (checked) {
            // let a = document.getElementById("music-mode");  
            // a.className = "btm-bar-icon selected";
            this.setState({
                isChecked: true,
                isShowHelpModal: true,
            });

            // let {
            //     isDominant
            // } = this.state;

            // let hasElem = document.getElementsByTagName("input[name='follow-me']");

            // if (hasElem) {
            //     if (hasElem.length) {
            //         hasElem[0].removeAttribute('checked');
            //     }
            // }

        } else {
            this.setState({
                isChecked: false,
                isNoHelpModal: true
                //isShowHelpModal: true,
            });

            // let obj = {
            //     dominant: true,
            //     room: window.location.href
            // };
            // // temp comment
            // socketEmit("domiantUrl", obj);

            // setTimeout(() => { location.reload(); }, 500);
        }
    }

    closeHelpModal = () => {
        this.setState({
            isShowHelpModal: false,
            isNoHelpModal: false
        });
    }


    onChangeDominant = (event: any) => {

        this.setState({
            isLoading: true
        })

        let _this = this;
        setTimeout(function () {
            _this.setState({
                isLoading: false
            })
        }, 30000)
        const { getLocalParticipant, userLoginData, isModerator, tokenDecodedData, authOrganization } = this.props;

        // Bypass Pre-Joining screen in music mode process
        sessionStorage.setItem("musicModeTimer", Math.round(new Date().getTime() / 1000))
        sessionStorage.setItem("music_tm_" + CURRENT_ROOM_NAME, Math.round(new Date().getTime() / 1000))

        let music_mode_internet_lost_data = {
            room: CURRENT_ROOM_NAME,
            location: window.location.origin,
            jitsiId: getLocalParticipant.id,
            musicMode: true
        }
        socketEmit("music_mode_internet_lost", music_mode_internet_lost_data);

        let obj = {
            dominant: false,
            roomLocation: CURRENT_ROOM_LOCATION,
            uid: getLocalParticipant.id,
            mode: true,
            isClaimed: userLoginData?.room ? true : false
        };

        // if (userLoginData.room) {
        if (userLoginData.room || (tokenDecodedData && tokenDecodedData != undefined)) {
            sessionStorage.removeItem("musicModeType_" + obj.roomLocation)
            sessionStorage.setItem("musicModeType_" + obj.roomLocation, JSON.stringify({
                type: "enableLoad",
                t: Math.round(new Date().getTime() / 1000),
            }));

            if (isModerator && !userLoginData.isAdmin) {
                sessionStorage.setItem("claimedUserD", JSON.stringify({
                    roomLocation: obj.roomLocation,
                    time: Math.round(new Date().getTime() / 1000),
                    roomName: CURRENT_ROOM_NAME,
                    isModerator: true
                }))
            }
        }

        if (tokenDecodedData) {
            let musicModeData = {
                method: "POST",
                music_mode: true,
                roomname: tokenDecodedData.roomName,
                school: tokenDecodedData.school,
                organization_id: authOrganization._id
            }
            musicModeStatus(musicModeData).then((e) => {

                console.log("music mode status ", e)
                dispatch(toggleLobbyMode(false));
                socketEmit("domiantUrl", obj);
                let room = CURRENT_ROOM_NAME;
                // if (room) {
                //     room = room.substring(1);
                // }

                sessionStorage.removeItem("conference_time_" + room);

                setTimeout(() => {
                    window.location.hash = MUSIC_MODE_STRING;
                    location.reload();
                }, 1000);
            })
        } else {

            dispatch(toggleLobbyMode(false));
            socketEmit("domiantUrl", obj);
            let room = CURRENT_ROOM_NAME;
            // if (room) {
            //     room = room.substring(1);
            // }

            sessionStorage.removeItem("conference_time_" + room);

            setTimeout(() => {
                window.location.hash = MUSIC_MODE_STRING;
                location.reload();
            }, 1000);
        }

        sendAnalytics({
            action: "toolbar clicked",
            category: "toolbar",
            source: "music mode ON"
        });
    };

    ifClickNoDominant = (event: any) => {
        this.setState({
            isLoading: true
        })

        let _this = this;
        setTimeout(function () {
            _this.setState({
                isLoading: false
            })
        }, 30000)

        const { getLocalParticipant, userLoginData, isModerator, tokenDecodedData, authOrganization } = this.props;

        // Bypass Pre-Joining screen in music mode process
        sessionStorage.setItem("musicModeTimer", Math.round(new Date().getTime() / 1000))
        sessionStorage.setItem("music_tm_" + CURRENT_ROOM_NAME, Math.round(new Date().getTime() / 1000))

        let music_mode_internet_lost_data = {
            room: CURRENT_ROOM_NAME,
            location: window.location.origin,
            jitsiId: getLocalParticipant.id,
            musicMode: false
        }
        socketEmit("music_mode_internet_lost", music_mode_internet_lost_data);

        let obj = {
            dominant: true,
            roomLocation: CURRENT_ROOM_LOCATION,
            uid: getLocalParticipant.id,
            mode: false,
            isClaimed: userLoginData?.room ? true : false
        };

        // if (userLoginData.room) {
        if (userLoginData.room || (tokenDecodedData && tokenDecodedData != undefined)) {
            sessionStorage.removeItem("musicModeType_" + obj.roomLocation)
            sessionStorage.setItem("musicModeType_" + obj.roomLocation, JSON.stringify({
                type: "disableLoad",
                t: Math.round(new Date().getTime() / 1000)
            }));
            if (isModerator && !userLoginData.isAdmin) {
                sessionStorage.setItem("claimedUserD", JSON.stringify({
                    roomLocation: obj.roomLocation,
                    time: Math.round(new Date().getTime() / 1000),
                    roomName: CURRENT_ROOM_NAME,
                    isModerator: true
                }))
            }
        }

        if (tokenDecodedData) {
            let musicModeData = {
                method: "POST",
                music_mode: false,
                roomname: tokenDecodedData.roomName,
                school: tokenDecodedData.school,
                organization_id: authOrganization._id
            }
            musicModeStatus(musicModeData).then(e => {
                console.log("music mode status off", e)

                dispatch(toggleLobbyMode(false));
                socketEmit("domiantUrl", obj);
                let room = CURRENT_ROOM_NAME;
                // if (room) {
                //     room = room.substring(1);
                // }

                setTimeout(() => {
                    window.location.hash = "#config.disableAP=false";
                    location.reload();
                }, 1000);
            })
        } else {
            dispatch(toggleLobbyMode(false));
            socketEmit("domiantUrl", obj);

            let room = CURRENT_ROOM_NAME;
            // if (room) {
            //     room = room.substring(1);
            // }

            sessionStorage.removeItem("conference_time_" + room);

            setTimeout(() => {
                window.location.hash = "#config.disableAP=false";
                location.reload();
            }, 1000);
        }

        sendAnalytics({
            action: "toolbar clicked",
            category: "toolbar",
            source: "music mode OFF"
        });
    };

    /**
     * Implements React's {@link Component#render}.
     *
     * @inheritdoc
     */

    render() {
        const { isDominant, isShowHelpModal, isNoHelpModal } = this.state;
        const { userLoginData, isModerator, withCheckbox, tokenDecodedData } = this.props;

        if (userLoginData.room) {
            if (!userLoginData.isAdmin && !userLoginData.isSecondaryModerator && !isModerator) {
                return null;
            }
        }

        if (tokenDecodedData) {
            if (tokenDecodedData.student == true) {
                if (withCheckbox) {
                    return <>
                        <div id="music-mode" className={`music-not-allow music-mode-${isDominant ? 'enabled' : 'disabled'}`}>
                            <Checkbox
                                checked={isDominant ? true : false}
                                label={ct("rta-trmc.musicMode.labelMusicMode")}
                                name='follow-me'
                                disabled={true}
                                className="theme-primary-checkbox"
                            />
                        </div>
                    </>
                }
                return null;
            }
        }

        if (this.props.usersData && !withCheckbox) {
            return null;
        }

        return (
            // <div id="music-mode" key='music' className="btm-bar-icon" style={{ display: isVisible }} >
            //     {isDominant ?
            //         <div className="btm-bar-icon selected">
            //             <span className="cus-tooltip">Disable Music Mode</span>
            //             <img src={musicmode} onClick={() => this._onClick(false)} />
            //         </div>
            //         :
            //         <div>
            //             <span className="cus-tooltip">Enable Music Mode</span>
            //             <img src={musicmode} onClick={() => this._onClick(true)} />
            //         </div>
            //     }
            //     {isShowHelpModal && this.renderHelpModal()}
            //     {isNoHelpModal && this.renderNoHelpModal()}
            // </div>
            <>
                {
                    withCheckbox ?
                        <div id="music-mode" key='music' className={`music-mode-${isDominant ? 'enabled' : 'disabled'}`} >
                            <Checkbox
                                checked={isDominant ? true : false}
                                label={ct("rta-trmc.musicMode.labelMusicMode")}
                                name='follow-me'
                                className="theme-primary-checkbox"
                                onChange={() => this._onClick(isDominant ? false : true)} />

                        </div>
                        :
                        <div id="music-mode" key='music' className={`btm-bar-icon toolbar-music-mode music-mode-${isDominant ? 'enabled' : 'disabled'}`}
                            onClick={
                                () => isDominant ? this._onClick(false) : this._onClick(true)
                            }
                        >
                            {isDominant ?
                                <div className="btm-bar-icon selected">
                                    <span className="cus-tooltip">{ct("rta-trmc.toolBox.disableMusicMode")}</span>
                                    <img src={musicmode} onClick={() => this._onClick(false)} />
                                </div>
                                :
                                <div>
                                    <span className="cus-tooltip">{ct("rta-trmc.toolBox.enableMusicMode")}</span>
                                    <img src={musicmode} onClick={() => this._onClick(true)} />
                                </div>
                            }
                        </div>
                }
                {isShowHelpModal && this.renderHelpModal()}
                {isNoHelpModal && this.renderNoHelpModal()}
            </>
        )
    }

    renderHelpModal() {
        let confirmMsg = ct("messages.musicModeOnModerator", "messages");
        let html = <></>;
        if (confirmMsg.indexOf("<br/>") != -1) {
            confirmMsg = confirmMsg.split("<br/>");
            html = <>{confirmMsg[0]}<br /><br />{confirmMsg[1]}</>
            if (getBaseConfig("deeplinking") == false) {
                html = <>{confirmMsg[0]}</>
            }
        } else {
            html = <>{confirmMsg}</>
        }

        const { isLoading } = this.state;
        return (
            <ModalTransition>
                    <Dialog
                    disableAutoHideOnSubmit={true}
                    disableBackdropClose={true}
                    hideCloseButton={true}
                    onCancel={() => this.closeHelpModal()}
                    cancel={{ hidden: true}}
                    ok={{ hidden: true }}
                    titleKey={ct("Translate.typography.confirmation")}
                    testId="music-mode-dialog"
                    zIndex={999}
                    rtaClassName="confirmation-modal-wrapper"
                    showHeader= {false}
                    >
                    <div className="end-session">
                        <div className="titleHelpModal">
                            {
                                html
                            }
                        </div>
                        <div className="footer-bottom">
                            {
                                !isLoading ?
                                    <button id='start-music-mode-btn' className="yes-host-btn" onClick={this.onChangeDominant}>{ct("rta-trmc.musicMode.startMusicMode")}</button>
                                    :
                                    <button id='start-music-mode-loading-btn' className="yes-host-btn">
                                        <span className="music-mode-loader"></span>
                                    </button>

                            }
                            <button id='cancel-music-mode-start-btn' className="no-host-btn" onClick={this.closeHelpModal}>{ct("Translate.buttonTitle.noSmall")}</button>
                        </div>
                    </div>
                    </Dialog>
            </ModalTransition>)
    }

    renderNoHelpModal() {
        const confirmMsg = ct("messages.musicModeOffModerator", "messages");
        const { isLoading } = this.state;

        return (
            <ModalTransition>
                <Dialog
                    disableAutoHideOnSubmit={true}
                    disableBackdropClose={true}
                    hideCloseButton={true}
                    onCancel={() => this.closeHelpModal()}
                    cancel={{ hidden: true}}
                    ok={{ hidden: true }}
                    titleKey={ct("Translate.typography.confirmation")}
                    testId="music-mode-dialog"
                    zIndex={999}
                    rtaClassName="confirmation-modal-wrapper"
                    showHeader= {false}
                    >
                    <div className="end-session">
                        <div className="titleHelpModal">{confirmMsg}</div>
                        <div className="footer-bottom">
                            {
                                !isLoading ?
                                    <button id='stop-music-mode-btn' className="yes-host-btn" onClick={this.ifClickNoDominant}>{ct("rta-trmc.musicMode.stopMusicMode")}</button>
                                    :
                                    <button id='stop-music-mode-loading-btn' className="yes-host-btn">
                                        <span className="music-mode-loader"></span>
                                    </button>

                            }
                            <button id='cancel-music-mode-stop-btn' className="no-host-btn" onClick={this.closeHelpModal}>{ct("Translate.buttonTitle.noSmall")}</button>
                        </div>
                    </div>
                </Dialog>
            </ModalTransition>)
    }
}

/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    const { permissions = {} } = state['features/base/devices'];

    return {
        usersData: state[FEATURE_CUSTOM_REDUX].usersData,
        userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
        tokenDecodedData: state[FEATURE_CUSTOM_REDUX].tokenDecodedData,
        conferenceJoined: state[FEATURE_CUSTOM_REDUX].conferenceJoined,
        authOrganization: state[FEATURE_CUSTOM_REDUX_V2].authOrganization,
        getLocalParticipant: state['features/base/participants'].local,
        isModerator: isLocalParticipantModerator(state)
    };
}


export default translate(connect(mapStateToProps)(MusicModeButton));
